import TextTag from "../Tag";
import "./index.css";

const BENEFITS = [
  {
    tag: "Time awareness",
    title: "Forget the burden of scheduling",
    description:
      "Most apps ask you to plan your future; Habit Time simply asks about your now. No more overflowing to-do lists or the stress of missed deadlines. Just an honest look at your day as it happens.",
  },
  {
    tag: "Daily timeline",
    title: "Log in the moment",
    description:
      "When the prompt hits, you answer, start the timer, and log your activity. It’s that simple. By documenting your current tasks rather than chasing future ones, you build an authentic record of your time.",
  },
  {
    tag: "Habit building",
    title: "Your day, unfolded.",
    description:
      "Watch a better timeline emerge—one that isn't a rigid plan, but a beautiful reflection of your actual habits unfolding along the way.",
  },
];

const WhyHabitTime = () => {
  return (
    <section className="wyg" id="how-it-works">
      <div className="wyg__header">
        <TextTag text="Why Habit Time" />
        <h2 className="wyg__title">
          Know your <span>daily habits</span>
        </h2>
        <p className="wyg__header-sub">
          No complex setup. We simply ask what you're doing and you're off. Log
          activities with a timer or countdown clock, and over time watch your
          daily routines turn into clear, measurable habits.
        </p>
      </div>

      <div className="wyg__grid">
        {BENEFITS.map(({ tag, title, description }) => (
          <div className="wyg__card" key={tag}>
            <h3 className="wyg__card-title">{title}</h3>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyHabitTime;
